/**
 * Actions due.
 *
 * Every rule is the server's. Nothing is computed here, because the counts have to
 * agree with the screens they link to and a second implementation is a second answer.
 */

import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import { useCurrentUser } from '@/features/auth/api';
import { can } from '@/lib/permissions';
import type { ActionsDue } from '@/api/schema';

export const NOTIFICATIONS_KEY = ['notifications'] as const;

export function useActionsDue() {
  const { data: user } = useCurrentUser();
  return useQuery({
    queryKey: [...NOTIFICATIONS_KEY, 'actions-due'],
    enabled: can(user, 'dashboard'),
    queryFn: () => api.get<ActionsDue>('/api/v1/notifications/actions-due'),
    // Nothing is stored, so a stale count is simply an old read. Two minutes is often
    // enough to feel live without asking the database every few seconds for a panel
    // most people glance at twice a day.
    refetchInterval: 120_000,
    refetchOnWindowFocus: true,
  });
}
